import { useEffect, useRef, useState } from 'react';
import { createStaffSocket } from '../lib/socket';
import { api } from '../services/api';

/**
 * Mantiene el recuento de ingredientes bajo umbral y escucha alertas en tiempo real
 * (evento `inventory:low_stock` del namespace /staff). Expone:
 *  - lowCount: número de ingredientes bajo umbral (inicial vía /usage + actualizaciones)
 *  - alert: última alerta recibida { ingredients, at } (para mostrar toast)
 *  - dismiss(): oculta el toast actual
 *  - refresh(): vuelve a consultar /usage
 */
export default function useLowStock() {
  const [lowCount, setLowCount] = useState(0);
  const [alert, setAlert] = useState(null);
  const lowNamesRef = useRef(new Set());

  const refresh = () => {
    api.get('/admin/inventory/usage')
      .then((data) => {
        lowNamesRef.current = new Set((data.low || []).map((i) => i._id));
        setLowCount(data.lowCount || 0);
      })
      .catch(() => {});
  };

  useEffect(() => {
    refresh();
    const socket = createStaffSocket();
    socket.on('inventory:low_stock', (payload) => {
      const ingredients = payload?.ingredients || [];
      if (!ingredients.length) return;
      ingredients.forEach((i) => lowNamesRef.current.add(i._id));
      setLowCount(lowNamesRef.current.size);
      setAlert({ ingredients, at: payload.at || new Date().toISOString() });
    });
    return () => socket.close();
  }, []);

  return { lowCount, alert, dismiss: () => setAlert(null), refresh };
}
